import "./VpnLatencyBenchmarks.module.css";
import Header from "@/reusable_sections/Header";
import Vpn from "./sections/Vpn";
import Vpnlatencyanalytics from "./sections/Vpnlatencyanalytics";
import Protocol from "./sections/Protocol";
import Gaming from "./sections/Gaming";
import Insights from "./sections/Insights";
import Affiliatemonetizationcta from "./sections/Affiliatemonetizationcta";
import Publicwifisecuritycta from "./sections/Publicwifisecuritycta";
import Footer from "@/reusable_sections/Footer";
export default function VpnLatencyBenchmarksPage() {
  return <div>
      <Header />
      <Vpn />
      <Vpnlatencyanalytics />
      <Protocol />
      <Gaming />
      <Insights />
      <Publicwifisecuritycta />
      <Affiliatemonetizationcta />
      <Footer />
    </div>;
}